import { render } from "./SolidIcon.vue?vue&type=template&id=7253340d"
import script from "./SolidIcon.vue?vue&type=script&lang=js"
export * from "./SolidIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__